import styled, {th} from 'quickstart/styled-components/system'

export const UniversalLink = styled.a`
  ${th(`links.unstyled`)};
`
